import React, { useState } from 'react';
import { AudioManager } from './AudioManager.ts';
import './MuteButton.css';

interface MuteButtonProps {
  audioManager: AudioManager;
}

export const MuteButton: React.FC<MuteButtonProps> = ({ audioManager }) => {
  const [muted, setMuted] = useState(audioManager.isMuted());

  const handleToggle = () => {
    const nowMuted = audioManager.toggleMute();
    setMuted(nowMuted);
  };

  return (
    <div className="mute-container">
      <div className="mute-box">
        <div className="mute-label">Audio</div>
        <button className="mute-btn" onClick={handleToggle} title={muted ? 'Unmute' : 'Mute'}>
          {muted ? 'OFF' : 'ON'}
        </button>
      </div>
    </div>
  );
};
